module.exports = __webpack_public_path__ + "img/thumb-fabrica.d2a69b96.jpeg";